/* eslint-disable */
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Import dependencies
import { initialiser } from '../utilitybelt';

// Import utilities
import getAriaLabel from './utilities/getAriaLabel';

var Pagination = function Pagination(config) {
  var _this = this;

  _classCallCheck(this, Pagination);

  this.init = function () {
    // Call bind events
    _this.bindEvents();
  };

  this.bindEvents = function () {
    _this.addAriaLabelsToItems();
  };

  this.addAriaLabelsToItems = function () {
    for (var i = 0; i < _this.paginationItems.length; i += 1) {
      var item = _this.paginationItems[i];
      var pageNum = item.textContent;
      item.setAttribute('aria-label', getAriaLabel(pageNum, item.parentElement));
    }
  };

  var el = config.el,
      settings = config.settings;

  // Set root element
  this.selector = el;

  // Set module dom sub elements e.g.
  this.paginationItems = el.querySelectorAll(settings.paginationItems);

  // Set settings
  this.settings = settings;
};

export default function(settings) {
  return initialiser(settings, Pagination);
} 